"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SelectField_1 = __importDefault(require("../Fields/SelectField"));
var Context_1 = require("../Context");
exports.default = react_1.default.forwardRef(function CardExpMonthField(props, ref) {
    var _a = props.expYearName, expYearName = _a === void 0 ? 'expYear' : _a, validate = props.validate, rest = __rest(props, ["expYearName", "validate"]);
    var form = (0, Context_1.useFormContext)();
    var validateMonth = function (value) {
        var values = form.values;
        var month = parseInt(value);
        var yearString = values[expYearName];
        var yearFirstTwoDigits = new Date().getFullYear().toString().substring(0, 2);
        var cardExpMonthYear = new Date(parseInt(yearFirstTwoDigits + yearString), month);
        // month with index 0, credit card expiration date lasts til the end of the month
        // when month = 6, year = 2022, comparing July, 2022 < today
        if (yearString // only validate when year is selected
            && cardExpMonthYear < new Date()) {
            return 'Expired';
        }
        return validate === null || validate === void 0 ? void 0 : validate(value);
    };
    return (react_1.default.createElement(SelectField_1.default, __assign({ ref: ref, name: 'expMonth', label: 'Exp. Month', placeholder: 'Exp. Month', validate: validateMonth, autoComplete: 'cc-exp-month', options: [
            { value: '', text: 'select', disabled: true },
            { value: '01', text: '01' },
            { value: '02', text: '02' },
            { value: '03', text: '03' },
            { value: '04', text: '04' },
            { value: '05', text: '05' },
            { value: '06', text: '06' },
            { value: '07', text: '07' },
            { value: '08', text: '08' },
            { value: '09', text: '09' },
            { value: '10', text: '10' },
            { value: '11', text: '11' },
            { value: '12', text: '12' },
        ] }, rest)));
});
